<ng-container *ngIf="costCenterState$ | async as state">
    <h1 mat-dialog-title class="active">
        {{"app.dialog.cost-center-reference-value.title.header" | translate: { kostenstelle: costCenter.name } }}
    </h1>
    <div mat-dialog-content>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoadingBezugsgroessen ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="dialogHeader">
            <mat-generic-input [fields]="layout.filterFields" (inputFormGroupChange)="onFormGroupChange($event)"></mat-generic-input>
            <button
                mat-mini-fab
                color="primary"
                matTooltip="{{ 'app.dialog.cost-center-reference-value.actions.add.label' | translate }}"
                (click)="onOpenDialog()"><mat-icon>add</mat-icon></button>
        </div>
                <table mat-table [dataSource]="dataSource">

                    <ng-container matColumnDef="costAccountingType">
                        <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-center-reference-value.cost-accounting-type.label" | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            {{state.costAccountingTypeLookup[ element.costAccountingTypeId ]?.name}}</td>
                    </ng-container>

                    <ng-container matColumnDef="reference">
                        <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-center-reference-value.reference.label" | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{state.referenceLookup[ element.referenceId ]?.name}}</td>
                    </ng-container>

                    <ng-container matColumnDef="validFrom">
                        <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-center-reference-value.validity.label" | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.validFrom | date: 'dd.MM.yyyy' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-center-reference-value.wert.label" | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            {{element.amount | number: '1.0-2' : 'de-DE'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element" class="actions">
                            <button mat-icon-button
                                    matTooltip="{{ 'app.dialog.cost-center-reference-value.actions.edit.label' | translate }}"
                                    (click)="onOpenDialog(element)">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button
                                    color="warn"
                                    matTooltip="{{ 'app.dialog.cost-center-reference-value.actions.delete.label' | translate }}"
                                    (click)="onDeleteReferenceValue(element)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="layout.columns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: layout.columns;"></tr>

                </table>
    </div>
</ng-container>
